import { log10 } from "chart.js/helpers";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const AccountDetails = (props) => {
  const [isAccountDisabled, setIsAccountDisabled] = useState(true);
  const [fields, setFields] = useState([
    {
      name: "bank_account_holder_name",
      label: "Account holder name",
      type: "text",
    },
    {
      name: "bank_account_number",
      label: "Account No.",
      type: "number",
    },
    {
      name: "reEnterAccountNumber",
      label: "Re-enter account No.",
      type: "text",
    },
    {
      name: "bank_account_type",
      label: "Account type",
      type: "select",
      options: _enum.ACCOUNT_TYPE,
    },
    {
      name: "bank_account_holder_bank_name",
      label: "Bank name",
      type: "select",
      options: [],
      required: true,
    },
    {
      name: "bank_account_holder_bank_IFSC",
      label: "IFSC code",
      type: "text",
    },
  ]);

  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };

  const handleAcknowledge = (e, data) => {
    let value = e.target.checked;
    setIsAccountDisabled(!value);
  };

  const updateFields = (data = {}) => {
    let allowedFields = [...fields.map((v) => v.name), "reEnterAccountNumber"];
    let updatedfields = Object.only(data, allowedFields);
    updatedfields.reEnterAccountNumber = data?.bank_account_number;

    let farr = Object.keys(updatedfields);
    console.log({ updateFields: data, updatedfields, farr });

    farr.forEach((name) => {
      let tfield = fields.find((o) => o.name === name);
      tfield.defaultValue = data[name];
    });
    setFields([...fields]);

    let reEnterAccountHolderNameField = fields.find(
      (o) => o.name === "reEnterAccountNumber"
    );
    reEnterAccountHolderNameField.defaultValue = data?.bank_account_number;
    setFields([...fields]);
  };

  const getBankNames = () => {
    let payload = {
      page: 1,
    };
    props.apis.apiGetBanknames(payload).then((res) => {
      console.log({ apiGetBanknames: res });
      let bankNameField = fields.find(
        (o) => o.name == "bank_account_holder_bank_name"
      );
      bankNameField.options = res;
      console.log({ bankNameField });
      setFields([...fields]);
    });
  };

  useEffect(() => {
    getBankNames();
    let accountDetails =
      props?.$store?.user?.created_by_connector_bank_account_details;

    if (accountDetails?.length > 0) {
      let {
        bank_account_holder_name,
        bank_account_number,
        reEnterAccountNumber,
        bank_account_type,
        bank_account_holder_bank_name,
        bank_account_holder_bank_IFSC,
      } = accountDetails[0] || {};

      let editData = {
        bank_account_holder_name,
        bank_account_number,
        reEnterAccountNumber,
        bank_account_type,
        bank_account_holder_bank_name,
        bank_account_holder_bank_IFSC,
      };

      updateFields(editData);
    }
  }, []);

  return (
    <>
      <AppForm className="container" onSubmit={props.onAccountSubmit}>
        {fields?.map((field, i) => {
          return (
            <div
              className={`col-12 col-md-${field?.customcolspan || 12} col-lg-6`}
              key={i}
            >
              <AppInput
                name={field?.name}
                label={field?.label}
                type={field?.type}
                defaultValue={field?.defaultValue || ""}
                options={field?.options || []}
                required={field?.required || false}
              ></AppInput>
            </div>
          );
        })}
        <div className="col-12 col-md-12 mt-4 d-flex justify-content-end">
          <button
            className="formdata-cancel-btn btn"
            onClick={(...args) => props.onHandleStep(...args, 2)}
          >
            Back
          </button>
          <button
            type="submit"
            className="btn btn-primary ms-3"
            // onClick={(...args) => handleAccInfoSubmit(...args)}
          >
            Save & Next
          </button>
        </div>
      </AppForm>
    </>
  );
};

export default constore(AccountDetails);
